import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { ToolbarEvent } from '../../core/events/toolbar.event';
import { FormBuilder, Validators } from '@angular/forms';
import { ContainerComponent } from '../../core/component/Container.Component';
import { Location } from '@angular/common';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { GenEnum } from '../shared/general.enum';
import { MenusService } from '../../core/service/menus.service';
@Component({
	selector: 'app-container',
	templateUrl: 'formcontainer.component.html'
})

export class AppContainerComponent extends ContainerComponent {

	menuid: number;
	@ViewChild('check') checked: ElementRef;
	dbname: any;
	id: any;
	screen: any;
	menucollection: any;
	jsoncollection: any = [];
	dbstxt: any;
	constructor(private toolbarEvent: ToolbarEvent, private fb: FormBuilder, public router: Router, public menuService: MenusService, private route: ActivatedRoute) {
		super();
		this.myForm = this.fb.group({});

	}
		// public modulename:any;
		// public screenname:any;
		moduletitile:any
	 async ngOnInit() {
	   
		  this.moduletitile = this.localStorage.get('modulename')
		   await this.menucolloninit();
	  }
	  resetTitle() {

		this.modulename = this.localStorage.remove('modulename');

		// this.title = ''; // Reset the title when clicking 'Home'
	  }

	async Back() {
		this.router.navigate(['home']);
		this.activatedRoute;
	}

	async dashboard(id) {

		let route: any = this.router;
		if (route && route.currentRouterState &&
			route.currentRouterState.snapshot &&
			route.currentRouterState.snapshot.root &&
			route.currentRouterState.snapshot.root.queryParams) {

			let data = route.currentRouterState.snapshot.root.queryParams;

			if (data && data.menuid && data.menucollection) {
				let jsonData = JSON.parse(data.menucollection);
				this.jsoncollection = jsonData;
				this.menuid = Number(data.menuid);

				let filterData = jsonData.filter(o => o.id === Number(data.menuid))[0];

				if (filterData && filterData.children) {
					let dashboardData = filterData.children.filter(o => o.menucatid === GenEnum.Menucategory.Dashboard)[0];

					if (dashboardData && dashboardData.children) {
						this.screen = dashboardData.children;

						if (id !== "") {
							this.dbstxt = id;
							var active = document.getElementById("mainmenu");
							active.classList.remove("activeclass");

							var element = document.getElementById("dashboardmenu");
							element.classList.add("activeclass");

							let navigationExtras: NavigationExtras = {
								queryParams: {
									menuid: Number(data.menuid),
									menucollection: JSON.stringify(this.jsoncollection)
								},
								replaceUrl: false
							};
							this.router.navigate([id], navigationExtras);
						}
					}
					else {
						console.log("Dashboard Does Not Exits");
					}
				}
			}
		}
	}

	async menucolloninit() {
		this.route.queryParams.subscribe(params => {
			if (params && params.menuid) {
				this.menuid = Number(params.menuid);
				if (params && params.menucollection) {
					this.menucollection = JSON.parse(params.menucollection);
					if (this.menuid !== undefined && this.menucollection !== undefined) {
						
						let filterData = this.menucollection.filter(o => o.id === Number(this.menuid))[0];
						if (filterData && filterData.children) {
							let dashboardData = filterData.children.filter(o => o.menucatid === GenEnum.Menucategory.Dashboard)[0];
							if (dashboardData && dashboardData.children) {
								this.menuService.dashboards = dashboardData.children;

							}
						}
					}
				}
			}
		});
	}

	Menu() {

		this.dbstxt = "";

		var active = document.getElementById("mainmenu");
		active.classList.add("activeclass");

		var dbmenu = document.getElementById("dashboardmenu");
		dbmenu.classList.remove("activeclass");

		if (this.menucollection) {

			let navigationExtras: NavigationExtras = {
				queryParams: {
					menuid: this.menuid,
					menucollection: JSON.stringify(this.menucollection)
				},
				replaceUrl: false
			};
			this.router.navigate(['menuview'], navigationExtras);

		}
	}

} 



// WEBPACK FOOTER //
// ./src/app/shell/formcontainer/formcontainer.component.ts